import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Tooltip, { THEME, POSITION } from '@mos-cat/tooltip';

import getDate from '../../helpers/date';

import AutosaveIcon from '../../assets/Autosave.svg';
import Button from '../Button/Button';

import './DraftLoadedInfo.pcss';

const DraftLoadedInfo = ({
  draftLoadedVersionDate,
  draftDeleted,
  draftLoading,
  draftError,
  handleDeleteDraft,
  loadDraftEmpty
}) => {
  const [date, setDate] = useState(null);
  const [tooltipIsVisible, setTooltipIsVisible] = useState(false);
  const [tooltipIsCleared, setTooltipIsCleared] = useState(false);

  useEffect(() => {
    setDate(draftLoadedVersionDate);
  }, [draftLoadedVersionDate]);

  useEffect(() => {
    setTooltipIsVisible(draftLoading);
  }, [draftLoading]);

  useEffect(() => {
    if (draftDeleted || draftError) {
      setTooltipIsVisible(true);

      setTimeout(() => {
        setTooltipIsVisible(false);
        setTooltipIsCleared(true);
      }, 4000);
    }

    return () => {
      setTooltipIsVisible(false);
    };
  }, [draftDeleted, draftError]);

  const handleClick = () => {
    handleDeleteDraft();
    loadDraftEmpty();
  };

  let tooltipContent = '';

  if (draftLoading) {
    tooltipContent = 'Автосохранение удаляется...';
  } else if (draftError) {
    tooltipContent = 'Ошибка удаления!';
  } else if (draftDeleted) {
    tooltipContent = 'Заявление очищено';
  }

  if (draftDeleted && tooltipIsCleared) {
    return null;
  }

  return (
    <div className="DraftLoadedInfo">
      <div className="DraftLoadedInfo__icon-wrapper">
        <AutosaveIcon className="DraftLoadedInfo__icon" />
      </div>
      <p>
        Заявление загружено из последнего автосохранения от
        {` `}
        {getDate(date)}.
        <br />
        Вы можете продолжить оформление заявления или
        {` `}
        <Tooltip
          className="DraftLoadedInfo__tooltip"
          wrapperClassName="DraftLoadedInfo__tooltip-wrapper"
          theme={draftError ? THEME.ATTENTION : THEME.INFO}
          open={tooltipIsVisible}
          position={POSITION.bottom}
          content={tooltipContent}
          appearanceDuration={200}
        >
          <Button onClick={handleClick} className="DraftLoadedInfo__button">
            начать оформление заявки заново
            <span className="DraftLoadedInfo__button-dot">.</span>
          </Button>
        </Tooltip>
      </p>
    </div>
  );
};

DraftLoadedInfo.propTypes = {
  draftLoadedVersionDate: PropTypes.number,
  draftLoading: PropTypes.bool,
  draftDeleted: PropTypes.bool,
  draftError: PropTypes.bool,
  handleDeleteDraft: PropTypes.func
};

DraftLoadedInfo.defaultProps = {
  draftLoadedVersionDate: null,
  draftLoading: false,
  draftDeleted: false,
  draftError: false,
  handleDeleteDraft: null
};

export default DraftLoadedInfo;
